import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getAnalytics } from "firebase/analytics";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCpcC5GhUx-Yv0eK3r89U6xECpdQdf3g9U",
  authDomain: "godai-studios.firebaseapp.com",
  projectId: "godai-studios",
  storageBucket: "godai-studios.appspot.com",
  messagingSenderId: "333807505275",
  appId: "1:333807505275:web:e98568c516c2617496f7de",
  measurementId: "G-MPZ7WLK8H4"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
const db = getFirestore(app);
const auth = getAuth(app);
const analytics = getAnalytics(app);

// Export Firebase services
export { app, db, auth, analytics };